var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "star2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.254,
    height: 37.67,
    viewBox: "0 0 39.254 37.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M21.232,1.911,25.125,9.8A2.361,2.361,0,0,0,26.9,11.092l8.706,1.265a2.361,2.361,0,0,1,1.309,4.028l-6.3,6.141a2.361,2.361,0,0,0-.679,2.09l1.487,8.671A2.361,2.361,0,0,1,28,35.776l-7.787-4.094a2.361,2.361,0,0,0-2.2,0l-7.787,4.094A2.361,2.361,0,0,1,6.8,33.287L8.29,24.616a2.361,2.361,0,0,0-.679-2.09l-6.3-6.141a2.361,2.361,0,0,1,1.309-4.028l8.706-1.265A2.361,2.361,0,0,0,13.1,9.8L17,1.911a2.361,2.361,0,0,1,4.235,0Z",
    transform: "translate(-0.595 -0.595)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M9.643,37.67A3.482,3.482,0,0,1,6.221,33.6l1.486-8.668a1.242,1.242,0,0,0-.358-1.1L1.052,17.7a3.476,3.476,0,0,1,1.926-5.929l8.7-1.264a1.246,1.246,0,0,0,.938-.681l3.89-7.885a3.477,3.477,0,0,1,6.235,0l3.891,7.886a1.244,1.244,0,0,0,.937.68l8.7,1.264A3.475,3.475,0,0,1,38.2,17.7l-6.3,6.139a1.239,1.239,0,0,0-.358,1.1L33.032,33.6a3.475,3.475,0,0,1-5.043,3.663l-7.783-4.091a1.242,1.242,0,0,0-1.159,0l-7.783,4.093a3.484,3.484,0,0,1-1.621.4ZM19.627,2.23a1.222,1.222,0,0,0-1.116.694L14.62,10.81A3.477,3.477,0,0,1,12,12.712L3.3,13.976A1.244,1.244,0,0,0,2.61,16.1l6.3,6.139a3.476,3.476,0,0,1,1,3.077L8.421,33.981a1.244,1.244,0,0,0,1.805,1.312L18.009,31.2a3.48,3.48,0,0,1,3.236,0l7.783,4.091a1.244,1.244,0,0,0,1.805-1.311l-1.486-8.668a3.472,3.472,0,0,1,1-3.075l6.3-6.14a1.244,1.244,0,0,0-.69-2.122l-8.7-1.264a3.475,3.475,0,0,1-2.617-1.9L20.743,2.924a1.222,1.222,0,0,0-1.116-.694Z",
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.171,
    y1: 0.5,
    x2: 0.912,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(1.108 1.107)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_377",
    "data-name": "Rectangle 377",
    width: 39.394,
    height: 35.643,
    transform: "translate(-0.611 -0.058)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAATCAYAAAB/TkaLAAAACXBIWXMAAAsSAAALEgHS3X78AAAAtElEQVQ4jbVUAQ7DIAgERf//PD+jLiSjoRbRLu6SJpVSOA4QSykdDiOcDgj/CkqjARGh931F2P8R1DJaNs8++lAIawV2gmlQjPF1ySsCV/kjm11ZTE2FqeU0e2+tud+JiLZZ8LnWCkxEzlZPKKUEWgJ+hImVREh4BEhnZXDDJPsvOn8T09LJO8vU3JjmnB8j9XYuR0xHymPnYblRs2BclZfotvs7jHQjZ/9gP7WfCufvUwD4AORjJrTxyfn6AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_378",
    "data-name": "Rectangle 378",
    width: 37.501,
    height: 39.376,
    transform: "translate(0.506 -0.818)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAACXBIWXMAAAsSAAALEgHS3X78AAAAyElEQVQ4ja1UCw7FIAjzd/8L+3kvupAgK+CyNVkykZQW1Pi7EL5C+pJsoqCgViTGaO4vwicKT3KhwhMyUiv3Him0CqiEfM1VeESQ0CKf/6iAzC1jDLMiT0Z9lDHYw5O+Epl0caTQUi2xEUprKSVX8c0yIiS01ra1HAoqtAg1BTw+1cr2oBNSeu+ujQkic88hGsqbF2gppEPLVcwv56wW0GKFN15eu1rrFqepI0LYQ+vq0VDQILbXhix7lrw8ujmbZQ0nQ1o5IYQ/mMr2NWOAuCgAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_379",
    "data-name": "Rectangle 379",
    width: 41.251,
    height: 39.376,
    transform: "translate(-1.37 -0.818)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAVCAYAAABCIB6VAAAACXBIWXMAAAsSAAALEgHS3X78AAAAz0lEQVQ4jbVUWw4DIQjEx/1PrG7DthikvJq2/LgRdpjB0XI9A34d9R+gGN1KYMNSivljRKh7Bd+oMRlnGklFPO8y/rQRjzfgiFUESHEAa6Be3lPR11phEa2WS7SG5oy1fWtM2jhdxlG4h8eBtXnWWk0FnhoTGF5SeR6/sy65gbO3D9lHjbYr5pwpaQTE89gIV+kesOyWvY2SFPf9zVi+ZBmrRbV9jGEWei6JCBwzjt4NOjzal4d3zJiAM/JlbWttHyjuUSN1FFZELsHYvgeABwQ5CzsYS/HqAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M21.232,1.911,25.125,9.8A2.361,2.361,0,0,0,26.9,11.092l8.706,1.265a2.361,2.361,0,0,1,1.309,4.028l-6.3,6.141a2.361,2.361,0,0,0-.679,2.09l1.487,8.671A2.361,2.361,0,0,1,28,35.776l-7.787-4.094a2.361,2.361,0,0,0-2.2,0l-7.787,4.094A2.361,2.361,0,0,1,6.8,33.287L8.29,24.616a2.361,2.361,0,0,0-.679-2.09l-6.3-6.141a2.361,2.361,0,0,1,1.309-4.028l8.706-1.265A2.361,2.361,0,0,0,13.1,9.8L17,1.911a2.361,2.361,0,0,1,4.235,0Z",
    transform: "translate(0.512 0.512)",
    opacity: 0.55,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGray);
export default __webpack_public_path__ + "static/media/star-gray.d3f65bbf7fb09bbeebc0e23f815ddda8.svg";
export { ForwardRef as ReactComponent };